/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalAppointments from './hospital-appointments';
import HospitalAppointmentsDetail from './hospital-appointments-detail';
import HospitalAppointmentsUpdate from './hospital-appointments-update';
import HospitalAppointmentsDeleteDialog from './hospital-appointments-delete-dialog';

const HospitalAppointmentsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalAppointments />} />
    <Route path="new" element={<HospitalAppointmentsUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalAppointmentsDetail />} />
      <Route path="edit" element={<HospitalAppointmentsUpdate />} />
      <Route path="delete" element={<HospitalAppointmentsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalAppointmentsRoutes;
